/*
 * @Author: lc 2631402207@qq.com
 * @Date: 2025-11-10 14:03:48
 * @LastEditors: lc 2631402207@qq.com
 * @LastEditTime: 2025-11-10 15:44:56
 * @FilePath: \senlan-ai-ui\src\stores\imageAtom.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// src/atoms/imageConfigAtom.ts
import { atom } from 'jotai'
import ratio from '@/assets/icon/ratio.svg'
import style from '@/assets/icon/style.svg'
/** 各类型配置项 */
export interface ConfigItem {
  key: keyof ImageConfig // 对应字段
  label: string // UI显示标题
  type: 'menu' | 'select' // 类型：下拉菜单 或 选择框
  icon?: React.ReactNode // 按钮图标
  options: { label: string; value: string | number }[] // 可选项
}

/** 全局配置状态类型 */
export interface ImageConfig {
  ratio: string
  style: string
  count: number
}

/** 默认状态 */
export const imageConfigAtom = atom<ImageConfig>({
  ratio: '1024*1024',
  style: '',
  count: 1,
})

/** 所有配置项（统一管理） */
export const configList: ConfigItem[] = [
  {
    key: 'ratio',
    label: '比例',
    type: 'menu',
    icon: <img src={ratio} alt="ratio" style={{ width: 20 }} />,
    options: [
      { label: '1:1 正方形, 头像', value: '1024*1024' },
      { label: '2:3 社交媒体, 自拍', value: '512*768' },
      { label: '3:4 经典比例, 拍照', value: '1024*1366' },
      { label: '4:3 文章配图, 插画', value: '1366*1024' },
      { label: '9:16 手机壁纸, 人像', value: '768*1366' },
      { label: '16:9 桌面壁纸, 风景', value: '1366*768' },
    ],
  },
  {
    key: 'style',
    label: '风格',
    type: 'menu',
    icon: <img src={style} alt="ratio" style={{ width: 16 }} />,
    options: [
      { label: '工业风', value: '工业风' },
      { label: '写实风格', value: '写实风格' },
      { label: '动漫', value: '动漫风格' },
      { label: '赛博朋克', value: '赛博朋克' },
      { label: '低多边形', value: '低多边形' },
      { label: '油画', value: '油画' },
    ],
  },
  {
    key: 'count',
    label: '数量',
    type: 'select',
    options: [
      { label: '1 张', value: 1 },
      { label: '2 张', value: 2 },
      { label: '3 张', value: 3 },
      { label: '4 张', value: 4 },
    ],
  },
]
